import React from "react"
import { Box, CircularProgress, CircularProgressProps } from '@mui/material';
import { styled } from '@mui/material';

const Loader = styled(CircularProgress)(({theme})=>({
  color: theme.palette?.theme.primary[500]
}))

const PageLoader = (props:CircularProgressProps) => {
	return <Box position="absolute" left='50%' top="50%">
    <Loader size={50} {...props}/>
  </Box>
};

export { PageLoader };
export default PageLoader;
